/*
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors  : Liu Dan
 * @LastEditTime : 2023-01-03 09:23:28
 * @Description: 专门写 交互接口的文件
 */

// 如果使用Mock, 则路径请求改变
const BASE_IP = process.env.VUE_APP_BASE_IP
const BASE_PORT = process.env.VUE_APP_BASE_PORT

/**
 *  开发环境，需要直接访问 云平台的 http 接口
 *  测试环境，也需要直接访问 云平台的 http 接口
 *
 *  生产环境，需要根据当前协议，选择使用 `https` 还是 `http` 协议
 */
// eslint-disable-next-line no-underscore-dangle
let BASE_ = ''
switch (process.env.VUE_APP_CURRENTMODE) {
  case 'development':
  case 'test':
    BASE_ = `http://${BASE_IP}:${BASE_PORT}`
    break
  case 'production':
  default:
    BASE_ = window.location.origin
    break
}

export const BASE = BASE_

/**
 * SERVER-STASTICS-IMAGE
 */
const SERVER_COVERAGE = `${BASE}/api/sta-image/v2`
export const GET_STATISTICS = ({
  year, periodType, period, satelliteGroupId, type, regionIdOrPushuser = '',
}) => `${SERVER_COVERAGE}/statistics/${year}/${periodType}/${period}/${satelliteGroupId}/${type}/${regionIdOrPushuser}`

export const GET_STATISTIC_HELP = `${SERVER_COVERAGE}/help/LASTEST`

//  year=2020&type=4&length=8&regionId=-&satelliteIds=15,14,13,12,11,10,9,7&taskType=1

// 系统字典
const SERVER_SYSTEM = `${BASE}/api/system/v1`
export const GET_SPOT_META_TYPE = `${SERVER_SYSTEM}/dic/code/SPOT_META_TYPE/item/s`

// 漠然回首图片
const SEVER_IMG_UPLOAD = `${BASE}/api/bulletin-picture/v1`
export const WEEK_IMG_ACTIVE = `${SEVER_IMG_UPLOAD}/picture/active`
export const WEEK_IMG_URL = `${SEVER_IMG_UPLOAD}/sign/get`
// 开工月报

// const SPOT_BASE_IP = '121.36.72.137'
const SERVER_SPOT = `${BASE}/api/spot/v2`
// const SERVER_SPOT = 'http://127.0.0.1:13275/api'
export const SPOT_LASTEST = `${SERVER_SPOT}/spotstatistics/lastest` // ?stage=201901
export const SPOT_LASTEST_BY_STAGES = `${SERVER_SPOT}/spotstatistics/batchids`
export const SPOT_RELATE_REGION = `${SERVER_SPOT}/spotmeta/relateRegion`
export const SPOT_STATISTICS = batchId => `${SERVER_SPOT}/spotstatistics/${batchId}`
export const SPOT_STATISTICS_BY_BATCHIDS = `${SERVER_SPOT}/spotstatistics/item/batchids`
export const SPOT_NUM_URL = ''
// regionIds=110000,120000,130000,140000,150000,210000,220000,230000,310000,320000,
// 330000,340000,350000,360000,370000,410000,420000,430000,440000,450000,460000,500000,
// 510000,520000,530000,540000,610000,620000,630000,640000,650000,710000,810000,820000
